import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Itemcategory } from './item-category';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class ItemcategoryService {
	
baseUrl = environment.baseUrl;

  private itemcategorysUrl = this.baseUrl + '/api/itemcategorys';  // URL to web api
  private getitemcategorylistUrl = this.baseUrl + '/api/itemcategorys/getitemcategorylist';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getItemcategorys (): Observable<Itemcategory[]> {
    return this.http.get<Itemcategory[]>(this.itemcategorysUrl)
  }

  
  getItemcategory(itemcategoryid: number): Observable<Itemcategory> {
    const url = `${this.itemcategorysUrl}/${itemcategoryid}`;
    return this.http.get<Itemcategory>(url);
  }
 
   AddItemCategory (itemcategory: Itemcategory): Observable<Itemcategory> {
     return this.http.post<Itemcategory>(this.itemcategorysUrl, itemcategory, httpOptions);
  }
 
  deleteitemcategory (itemcategoryid: number | number): Observable<Itemcategory> {    
    const url = `${this.itemcategorysUrl}/${itemcategoryid}`;
 
    return this.http.delete<Itemcategory>(url, httpOptions);
  }
 
   UpdateItemCategory (itemcategory: Itemcategory): Observable<any> {
    return this.http.put(this.itemcategorysUrl, itemcategory, httpOptions);
  }
}